export default function callBack() {
  const phoneSubmit = document.getElementById('callback-submit');
  const phoneInput = document.getElementById('callback-input');

  if(phoneSubmit && phoneInput) {
    phoneSubmit.addEventListener('click', () => {
      goToCall();
    });
    phoneInput.addEventListener('keyup', (e) => {
      checkNumber(phoneInput.value);
      // Handle enter
      if(e.keyCode === 13) {
        goToCall();
      }
    })
  }

  /**
   * Go to the callback page
   */
  function goToCall() {
    let phoneNumber = document.getElementById('callback-input').value;
    // Remove spaces
    phoneNumber = phoneNumber.replace(/\s/g, '');
    if(checkNumber(phoneNumber)) {
      const url = createURL(phoneNumber);
      const event = new MouseEvent('click', {
        'view': window,
        'bubbles': false,
        'cancelable': true
      });
      url.dispatchEvent(event);
    }
  }

  /**
   * Create the right url
   * @param {string} number the number that should be added to the url
   */
  function createURL(number) {
    let url = document.createElement('a');
    url.href = phoneSubmit.dataset.url + number;
    url.target = '_blank';
    url.rel = 'noopener';
    return url;
  }

  /**
   * Check the validity of the phone number
   * @param {string} number the phone number to check
   */
  function checkNumber(number) {
    if (number.length > 0) {
      const phoneReg = new RegExp(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g);
      if(phoneReg.test(number)) {
        throwState('success');
        return true;
      } else {
        throwState('error');
      }
    }
  }

  /**
   * Show states (success or error)
   * @param {string} state error or success
   */
  function throwState(state) {
    const formGroup = phoneSubmit.parentElement.parentElement;
    const formMsg = phoneSubmit.parentElement.nextElementSibling;
    switch(state) {
      case 'error':
        if(formGroup.classList.contains('form-group--has-success')) {
          formGroup.classList.remove('form-group--has-success');
        }
        if (!formGroup.classList.contains('form-group--has-danger')) {
          formGroup.classList.add('form-group--has-danger');
          formMsg.classList.remove('u-display--none');
        }
        break;
      case 'success':
        if (formGroup.classList.contains('form-group--has-danger')) {
          formGroup.classList.remove('form-group--has-danger');
        }
        if (!formGroup.classList.contains('form-group--has-success')) {
          formGroup.classList.add('form-group--has-success');
          formMsg.classList.add('u-display--none');
        }
    }
  }
}

